import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title, 
  value, 
  unit, 
  trend, 
  trendValue, 
  status, 
  icon, 
  lastUpdate,
  onClick 
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'success':
        return 'border-success/30 bg-success/5';
      case 'warning':
        return 'border-warning/30 bg-warning/5';
      case 'error':
        return 'border-error/30 bg-error/5';
      default:
        return 'border-border bg-card';
    }
  };

  const getStatusIconColor = () => {
    switch (status) {
      case 'success':
        return 'text-success';
      case 'warning':
        return 'text-warning';
      case 'error':
        return 'text-error';
      default:
        return 'text-primary';
    }
  };

  const getTrendColor = () => {
    return trend === 'up' ? 'text-success' : trend === 'down' ? 'text-error' : 'text-muted-foreground';
  };

  const getTrendIcon = () => {
    return trend === 'up' ? 'TrendingUp' : trend === 'down' ? 'TrendingDown' : 'Minus';
  };

  return (
    <div 
      className={`rounded-xl border-2 p-4 md:p-5 lg:p-6 transition-all duration-250 hover:shadow-md ${getStatusColor()} ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex items-center gap-2 md:gap-3">
          <div className={`p-2 rounded-lg ${getStatusIconColor()} bg-current/10`}>
            <Icon name={icon} size={20} className={getStatusIconColor()} />
          </div>
          <h3 className="text-xs md:text-sm font-medium text-muted-foreground">{title}</h3>
        </div>
        {status && (
          <div className={`w-2 h-2 rounded-full ${status === 'success' ? 'bg-success' : status === 'warning' ? 'bg-warning' : 'bg-error'} animate-pulse`} />
        )}
      </div>

      <div className="space-y-2 md:space-y-3">
        <div className="flex items-baseline gap-2">
          <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground font-data">
            {value}
          </span>
          {unit && (
            <span className="text-sm md:text-base text-muted-foreground font-data">{unit}</span>
          )}
        </div>

        <div className="flex items-center justify-between">
          {trend && trendValue && (
            <div className={`flex items-center gap-1 ${getTrendColor()}`}>
              <Icon name={getTrendIcon()} size={14} />
              <span className="text-xs md:text-sm font-medium font-data">{trendValue}</span>
            </div>
          )}
          {lastUpdate && (
            <span className="text-xs text-muted-foreground caption ml-auto">
              {lastUpdate}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricCard;